module.exports = __webpack_public_path__ + "static/uspto-dd460bc536d64bf907a8a7bc328f5327.jpg";